import axios from 'axios';
import { notification } from 'antd';

export const useCreate = async (url, payload = {}) => {
  try {
    const header = {
      headers: { Authorization: localStorage.getItem('token') },
      timeout: 120000,
    };

    const dataRes = await axios.post(url, payload, header);
    return dataRes;
  } catch (error) {
    if (error?.response?.status === 401) {
      notification.error({
        message: 'Unauthorized, please relogin to proceed',
      });
      localStorage.clear();
      window.location.reload();
      return;
    }

    return error.response || error.request;
  }
};
